import { useDownloadURL } from "astrid-firestore/src/hooks";

export default function useAgreementDownloadURL({ agreement }) {
	return useDownloadURL({
		bucket: agreement?.signedAgreementFile?.bucket,
		fullPath: agreement?.signedAgreementFile?.fullPath,
	});
}
